import { createContext } from 'react';

export const ResourceEditorContext = createContext<{
  courseEnrolmentId?: number;
  resourceVersionId: number;
  resourceId: string;
}>(null as any);
